@if (showAlert) {
    <div class="alert alert-primary text-center">
        {{ 'ALERTS.UPDATE_IN_PROGRESS' | translate }}
    </div>
}
